var _ellipse, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.9238,
    cy: 10.7378,
    rx: 10,
    ry: 10.0469,
    fill: "#35475D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2894 11.3857V13.6808H7.30197V11.3857H5.95898V14.3554C5.95898 14.7278 6.2592 15.0297 6.63148 15.0297H14.9599C15.3319 15.0297 15.6324 14.7281 15.6324 14.3554V11.3857H14.2894Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6727 11.1582L8.74996 8.82397C8.74996 8.82397 8.45741 8.54647 8.77464 8.54647C9.09188 8.54647 9.8581 8.54647 9.8581 8.54647C9.8581 8.54647 9.8581 8.3598 9.8581 8.07191C9.8581 7.25115 9.8581 5.75742 9.8581 5.14847C9.8581 5.14847 9.81507 4.98291 10.0633 4.98291C10.3134 4.98291 11.4092 4.98291 11.5884 4.98291C11.7672 4.98291 11.7632 5.12233 11.7632 5.12233C11.7632 5.71285 11.7632 7.25819 11.7632 8.05214C11.7632 8.30953 11.7632 8.47643 11.7632 8.47643C11.7632 8.47643 12.3776 8.47643 12.7632 8.47643C13.1482 8.47643 12.8583 8.76699 12.8583 8.76699C12.8583 8.76699 11.2224 10.9488 10.9943 11.1777C10.8301 11.3436 10.6727 11.1582 10.6727 11.1582Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10.0469,
    fill: "white",
    transform: "translate(5.79688 4.98291)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadCircle);
export default __webpack_public_path__ + "static/media/download_circle.0f7603cbaf570a4c197984b03976c310.svg";
export { ForwardRef as ReactComponent };